import _ from 'lodash'
import Cookies from 'js-cookie'
import { fmtInteger } from './fmtNumber'
import { toFixed } from '@helpers/numberUtils'
//  这个要根据后台的格式
export default function generateDisplayFormat(st/*state from FormatConfigDialog*/) {
  return {
    column_unit_name: st ? st.columnUnitName : '',
    display_mode: st ? st.displayMode : 'num',
    thousand_point_separator: st ? +st.num.thousandPointSeparator : 1,      // to number
    fixed_decimal_places: st ? st[st.displayMode].fixedDecimalPlaces : 0,
    unit: st ? st.num.unit : '无'
  }
}
//生成报告跳转设置
export function generateUrlSetting(st/*state from FormatConfigDialog*/) {
  let url_setting = {}
  if (st && st.directType === 'dims') {
    url_setting = {
      target_dashboard_id: st.selectedScreen[0] ? st.selectedScreen[0] : '',
      dashboard_name: st.selectedScreenName,
      direct_way: st.directWay,
      dashboard_filter_id: st.dashboard_filter_id,
      target_type: st.target_type,
      target: st.target_type === 'url' ? st.target : '',
      token: st.tokenChecked,
      isOpen: st.checked
    }
  } else if (st && st.directType === 'numerices') {
    url_setting = {
      dashboard_name: st.selectedScreenName,
      direct_way: st.directWay || 1,
      related_dims: st.target_type === 'dashboard' ? st.related_dims : [],
      target_type: st.target_type,
      target: st.target_type === 'url' ? st.target : st.selectedScreen[0],
      token: st.tokenChecked,
      isOpen: st.checked
    }
  }
  return url_setting
}

function concatUrlList(list, newlist) {
  let curList = []
  if (list.length > 0) {
    if (list[list.length - 1].url === newlist[0].url) {
      list.push(newlist[1])
      curList = list
    } else {
      curList = curList.concat(newlist)
    }
  } else {
    curList = curList.concat(newlist)
  }
  return curList
}
function getParams(name) {
  const search = window.location.href
  //alert(search);
  const pattern = new RegExp(`[?&]${name}=([^&]+)`, 'g')
  const matcher = pattern.exec(search)
  let items = null
  if (matcher !== null) {
    try {
      items = decodeURIComponent(decodeURIComponent(matcher[1]))
    } catch (e) {
      try {
        items = decodeURIComponent(matcher[1])
      } catch (exception) {
        items = matcher[1]
      }
    }
  }
  return items
}
//生成报告跳转url
export function generateReportRedirectUrl(config, value, name, cb) {
  let url = null
  const code = getParams('code')
  const urlCode = getParams('code') || Cookies.get('tenant_code') || localStorage.getItem('tenant_code')
  //新接口改动dashboard_filter_id变为id数组,所以处理前统一进行一次转换
  let idList = []
  if (typeof config.dashboard_filter_id === 'string') {
    idList.push(config.dashboard_filter_id)
  } else if (Array.isArray(config.dashboard_filter_id)) {
    idList = config.dashboard_filter_id
  }
  // 用于匹配是否为应用门户内的跳转
  // 格式/app/index/[appid]/[funcid]/[jumpid]?type=...
  const appReg = /^\/app(\/[^/]+)(\/[^/]+)(\/[^/]+)(\/[^/]+)?/
  //新增dashboard_filter_id不存在，即直接跳转处理
  if (idList.length > 0 && config.target_type === 'dashboard') {
    let requestUrl = '/api/dashboard_chart/filter/info'
    const data = { dashboard_filter_id: idList.toString() }
    if (code) {
      requestUrl = '/api/released_dashboard_chart/filter/info'
      data.code = code
    }
    $.ajax({
      type: 'get',
      url: requestUrl,
      data
    }).then((res) => {
      if (res.result) {
        const reportList = []
        //报告名称
        const dashboard_name = res.data[0] ? res.data[0].dashboard_name : ''
        res.data.forEach((item, i) => {
          const col_name = item.col_name || ''
          //拼接筛选对象
          if (typeof value === 'string' || typeof value === 'number') {
            reportList.push({
              col_name,
              operator: '=',
              col_value: value
            })
          } else if (typeof value === 'object') {
            value[idList[i]].forEach((v) => {
              reportList.push({
                col_name,
                operator: v.operator,
                col_value: v.value
              })
            })
          }
        })
        //兼容target和target_dashboard_id
        const target = config.target || config.target_dashboard_id
        const { location } = window
        const matchAppUrl = location.pathname.match(appReg)
        //当code不存在时 只能跳转到priview
        if (Array.isArray(matchAppUrl)) {
          url = `/app${matchAppUrl[1]}${matchAppUrl[2]}${matchAppUrl[3]}/${target}?type=reportjump`
        } else {
          url = `/dataview/share/${target}?code=${urlCode}&type=reportjump`
        }
        reportList.forEach((list) => {
          //拼接筛选条件
          url = `${url}&df_${list.col_name}=${JSON.stringify(list)}`
        })
        const currentUrl = `${decodeURI(window.location.pathname)}${decodeURI(window.location.search)}`
        const currenObj = { name, url: currentUrl }
        const nextObj = { name: dashboard_name || config.dashboard_name || config.target_dashboard_name, url }
        let urlList = JSON.parse(localStorage.getItem('urlList')) || []
        urlList = concatUrlList(urlList, [currenObj, nextObj])
        localStorage.setItem('urlList', JSON.stringify(urlList))
        cb(url)
      }
    })
  } else if (config.target_type === 'dashboard') {
    //兼容target和target_dashboard_id
    const target = config.target || config.target_dashboard_id
    const { location } = window
    const matchAppUrl = location.pathname.match(appReg)

    if (Array.isArray(matchAppUrl)) {
      // 如果是应用门户的情况
      url = `/app${matchAppUrl[1]}${matchAppUrl[2]}${matchAppUrl[3]}/${target}?type=reportjump`
    } else if (urlCode) {
      // 存在code时一律跳转到share
      url = `/dataview/share/${target}?code=${urlCode}&type=reportjump`
    } else {
      //当code不存在时 只能跳转到priview
      url = `/dataview/preview/${target}?type=reportjump`
    }
    const currentUrl = `${decodeURI(location.pathname)}${decodeURI(location.search)}`
    const currenObj = { name, url: currentUrl }
    const nextObj = { name: config.dashboard_name || config.target_dashboard_name, url }
    let urlList = JSON.parse(localStorage.getItem('urlList')) || []
    urlList = concatUrlList(urlList, [currenObj, nextObj])
    localStorage.setItem('urlList', JSON.stringify(urlList))
    cb(url)
  } else if (config.target_type === 'url') {
    //直接跳转
    url = config.target
    if (config.userToken && config.token) {
      url = url.indexOf('?') > -1 ? `${url}&token=${config.userToken}` : `${url}?token=${config.userToken}`
    }
    cb(url, true)
  }
}

/**
 * 处理标准单图报告跳转逻辑
 * type暂时分为两种table_like, echart_like 因为table表格的取数据的key需要加一个_
 * col_value为点击跳转项的回调值
 * dashboardName为当前报告的名称
 * rowObj主要服务于数值字段跳转时，取维度字段值
 * callback为单图内的跳转逻辑处理
 * paramsConditions为后台返回的条件参数conditions
*/
export function chartReportRedirect(type, config, col_value, dashboardName, rowObj, callback, paramsConditions) {
  const colValues = {}
  const filterIds = []
  const obj = _.cloneDeep(config)
  //dashboard_filter_id和related_dims应该互斥
  if (config.dashboard_filter_id) {
    colValues[config.dashboard_filter_id] = [{ value: col_value, operator: '=' }]
    filterIds.push(config.dashboard_filter_id)
  } else if (config.related_dims && config.related_dims.length > 0 && rowObj) {
    config.related_dims.forEach((dim) => {
      const key = type === 'table_like' ? `_${dim.chart_alias}` : dim.chart_alias
      const value = rowObj[key]
      if (value) {
        colValues[dim.dashboard_filter_id] = [{ value, operator: '=' }]
        filterIds.push(dim.dashboard_filter_id)
      }
    })
  }
  if (config.jump_params.length > 0) {
    //拼接 条件参数跳转条件
    config.jump_params.forEach((param) => {
      const _index = _.findIndex(paramsConditions, c => c.dataset_field_id === param.param_dataset_field_id)
      if (_index > -1) {
        filterIds.push(param.dashboard_filter_id)
        if (Array.isArray(colValues[param.dashboard_filter_id])) {
          colValues[param.dashboard_filter_id].push({
            value: paramsConditions[_index].col_value,
            operator: paramsConditions[_index].operator
          })
        } else {
          colValues[param.dashboard_filter_id] = [{
            value: paramsConditions[_index].col_value,
            operator: paramsConditions[_index].operator
          }]
        }
        const __index = _.findIndex(paramsConditions, c => c.dataset_field_id === param.param_dataset_field_id, _index + 1)
        if (__index > -1) {
          colValues[param.dashboard_filter_id].push({
            value: paramsConditions[__index].col_value,
            operator: paramsConditions[__index].operator
          })
        }
      }
    })
  }
  obj.dashboard_filter_id = filterIds
  generateReportRedirectUrl(obj, colValues, dashboardName, callback)
}

// 根据数据和有效位数计算单位和小数位数
function handleSmartNumFormat(formatObj, value) {
  const absValue = Math.abs(value)
  const { num_valid_places, separate_config_decimal_places, fixed_decimal_places } = formatObj


  // 关闭自适应小数位、开启千分位分割、根据数值调整单位
  _.set(formatObj, 'justify_decimal', 0)
  _.set(formatObj, 'thousand_point_separator', 1)

  let intPlaces = parseInt(absValue, 10).toString().length // 整数位数

  if (intPlaces > 8) {
    _.set(formatObj, 'unit', '亿')
    _.set(formatObj, 'hidden_unit', 0)
    intPlaces -= 8
  } else if (intPlaces > 4) {
    _.set(formatObj, 'unit', '万')
    _.set(formatObj, 'hidden_unit', 0)
    intPlaces -= 4
  } else {
    _.set(formatObj, 'unit', '无')
    _.set(formatObj, 'hidden_unit', 1)
  }
  let decimalPlaces = 0 // 小数位数
  if (num_valid_places > intPlaces) decimalPlaces =  num_valid_places - intPlaces

  if (separate_config_decimal_places) {
    // 小数位单独配置,只智能调整单位
    _.set(formatObj, 'fixed_decimal_places', fixed_decimal_places)
  } else {
    _.set(formatObj, 'fixed_decimal_places', decimalPlaces)
  }
}

function formatWithUint(formatObj, value) {
  return formatObj.unit === '无' ? value : (value + formatObj.unit)
}
function formatNumber(formatObj, value, withUnit) {
  let fV = +value
  if (formatObj && formatObj.display_mode === 'num') {
    // 开启“智能数值显示”
    if (formatObj.smart_num_format) {
      handleSmartNumFormat(formatObj, value)
    }
    if (Number.isNaN(fV)) {
      return withUnit && !formatObj.hidden_unit ? formatWithUint(formatObj, value) : value
    }
    switch (formatObj.unit) {
      case '万':
        fV /= 1E4
        break
      case '亿':
        fV /= 1E8
        break
      case '无':
      default:
        break
    }
    // 固定小数位数
    let fixedDecimalPlaces = formatObj.fixed_decimal_places

    if (!formatObj.justify_decimal || Number.isNaN(+(formatObj.justify_decimal_places))) {
      fV = toFixed(fV, formatObj.fixed_decimal_places)
    } else {
      // 需求设计如此 https://www.tapd.cn/38229611/prong/stories/view/1138229611001040357
      const x = +(formatObj.justify_decimal_places)
      const n = +(formatObj.fixed_decimal_places)
      const s = (Math.floor(Math.abs(fV)).toString()).length
      if (x >= (s + n)) {
        fV = toFixed(fV, x - s + 1)
        fixedDecimalPlaces = x - s + 1
      } else {
        fV = toFixed(fV, formatObj.fixed_decimal_places)
      }
    }
    // 千分位使用逗号
    if (formatObj.thousand_point_separator) {
      if (fixedDecimalPlaces > 0) {
        const numSplits = fV.split('.')
        fV = `${fmtInteger(numSplits[0])}.${numSplits[1]}`
      } else {
        fV = fmtInteger(fV)
      }
    }
    // 添加单位
    fV = withUnit && !formatObj.hidden_unit ? formatWithUint(formatObj, fV) : fV
    return fV
  } else if (formatObj && formatObj.display_mode === 'percentage') {
    if (Number.isNaN(fV)) {
      return `${value}%`
    }
    return `${toFixed((fV * 100), formatObj.fixed_decimal_places)}%`
  }
  return value
}

export function formatDisplay(value, formatObj = {}, withUnit = true) {
  //新增数据为空与数据不为空的处理
  if (formatObj && formatObj.display_mode) {
    return formatNumber(formatObj, value, withUnit)
  }
  return value
}

export function specialFormatDisplay(value, formatObj = {}, withUnit = true) {
  //新增数据为空与数据不为空的处理
  if (value && formatObj.display_mode !== 'dim') {
    return formatNumber(formatObj, value, withUnit)
  } else if (formatObj) {
    //数据为空的处理
    const { show_empty_way, show_null_way, show_zero_way } = formatObj
    if (value === null) {
      //null值处理
      switch (show_null_way) {
        case undefined:
        case 'default':
          value = ''
          break
        case '_0':
          value = '0'
          break
        default:
          value = show_null_way
      }
    } else if (value === '') {
      //空值处理
      switch (show_empty_way) {
        case undefined:
        case 'default':
          break
        case '_0':
          value = '0'
          break
        default:
          value = show_empty_way
      }
    } else if (value === 0) {
      switch (show_zero_way) {
        case undefined:
        case 'default':
          value = formatNumber(formatObj, value, withUnit)
          break
        case '_empty':
          value = ''
          break
        default:
          value = show_zero_way
      }
    }
  }
  return value
}

/**
 * 用于自适应小数位数需求的部分图表，比如 numerical_value 中自定义的 fixed 数值
 * 需求 https://www.tapd.cn/38229611/prong/stories/view/1138229611001040357
 * @param value
 * @param formatObj
 * @return {*}
 */
export function toJustifyDecimalFixed(value, formatObj) {
  const number = +value

  if (Number.isNaN(number)) {
    return value
  }

  if (typeof formatObj === 'number' && formatObj >= 0) {
    return toFixed(number, formatObj)
  }

  if (typeof formatObj !== 'object') {
    return value
  }

  const { fixed_decimal_places, justify_decimal, justify_decimal_places } = formatObj

  if (!justify_decimal || Number.isNaN(+(justify_decimal_places))) {
    return toFixed(number, fixed_decimal_places)
  } else {
    const x = +(justify_decimal_places)
    const n = +(fixed_decimal_places)
    const s = (Math.floor(Math.abs(number)).toString()).length
    if (x >= (s + n)) {
      return toFixed(number, x - s + 1)
    } else {
      return toFixed(number, fixed_decimal_places)
    }
  }
}
